
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { CustomFieldDto, CustomFieldTypes, CustomFieldValues } from "@/store/custom-fields/types";
import { truncateString } from "@/filters";
import IconUpload from "@/components/IconUpload.vue";
import CustomFieldDatePicker from "@/components/custom-fields/CustomFieldDatePicker.vue";
import { customFieldMixins } from "@/mixins/customFieldMixins";
import { Constants } from "@/types/Constants";
import { CustomFieldConstants } from "@/mixins/customFieldMixins";
import vSelect3 from "vselect3";

const { convertCustomFieldDateValue } = customFieldMixins.methods;

@Component({
	filters: { truncateString },
	components: {
		"icon-upload": IconUpload,
		"custom-field-date-picker": CustomFieldDatePicker,
		"v-select-3": vSelect3,
	}
})

export default class CustomDefinedField extends Vue {
	@Prop({ type: Object, required: true }) public value: CustomFieldValues;
	@Prop({ type: Object, required: true }) public setting: CustomFieldDto;
	@Prop({ type: Number, default: 250 }) public maxCharacters: number;
	@Prop({ type: Boolean, default: false}) public isEditable: boolean;
	@Prop({ type: Boolean, default: false }) public isStatusDisplay: boolean;
	@Prop({ type: Boolean, default: false }) public belongsToGroupSync: boolean;

	private type: string;
	private CFTextLength: number = CustomFieldConstants.CF_TEXT_LENGTH;
	private CFTextAreaLength: number = CustomFieldConstants.CF_TEXTAREA_LENGTH;
	private CFHyperlinkLength: number = CustomFieldConstants.CF_HYPERLINK_LENGTH;
	private CFNumberMax: number = Constants.MAXIMUM_INTEGER_VALUE;
	private CFNumberMin: number = Constants.MINIMUM_INTEGER_VALUE;

	@Watch("type")
	private beforeMount(): void {
		this.type = CustomFieldTypes[this.setting?.customFieldTypeId];
	}

	private get checkboxValue(): boolean {
		return this.value.value == "true" ? true : false;
	}

	private get customFieldNumberState(): boolean {
		if(this.value.value) {
			return this.value.value <= this.CFNumberMax && this.value.value >= this.CFNumberMin;
		}

		return true;
    }

	private getConvertedCustomFieldDateValue(date: string): string {
		return convertCustomFieldDateValue(date);
	}

	private get typeToLowerCase(): string {
		return this.type?.toLowerCase();
	}

	private isType(customFieldType: string): boolean {
		if (!(customFieldType in CustomFieldTypes)) {
			return false;
		}

		return this.typeToLowerCase === customFieldType?.toLowerCase();
	}

	private updateValue(emittedValue: string): void {
		if (this.value?.value != emittedValue) {
			this.value.value = emittedValue;
			this.onValueChange();
		}
	}

	private onSelected(updatedValue): void {
		if (!updatedValue) {
			this.value.value = "";
		} else {
			this.value.value = updatedValue;
		}

		this.onValueChange();
	}

	private onValueChange(): void {
		if (this.setting.customFieldTypeId == CustomFieldTypes.List && typeof(this.value.value) == 'object') {
			this.value.value = this.value.value.join(", ");
		}
		this.$emit('CFValueChanged', this.value);
	}

	private get isCustomFieldSyncControlled(): boolean {
		return this.belongsToGroupSync && 
			this.setting.externalIds != null && 
			this.setting.externalIds.length > 0;
	}
}
